import { FunctionComponent, MouseEvent } from 'react';

// Styles
import styles from './ButtonTawkTo.module.scss';

// Config
import { supportClass } from '@Config/tawk';

// Utilities
import classnames from 'classnames';

interface ButtonTawkToProps {
    className?: string;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
}

const ButtonTawkTo: FunctionComponent<ButtonTawkToProps> = ({ onClick, className, children }) => {
    const openTawkTo = (event: MouseEvent<HTMLElement>) => {
        if (onClick) {
            onClick(event);
        }
    };

    const buttonClassName = classnames([supportClass, styles.button, className]);

    return (
        <div className={buttonClassName} onClick={openTawkTo}>
            {children}
        </div>
    );
};

export default ButtonTawkTo;
